import { useMemo } from "react";
import { toast } from "sonner";
import { LapImport } from "@/components/LapImport";
import { LapMeta, LapStats } from "@/components/LapStats";
import { LapTable } from "@/components/LapTable";
import { LapChart } from "@/components/LapChart";
import { useT } from "@/lib/i18n";
import { fmtLap, lapStats } from "@/lib/laps";

const KEYS = { 1: ["lap_data", "best_lap", "laps", "lap"], 2: ["lap_data2", "best_lap2", "laps2", "lap2"] };

const StintLaps = ({ n, form, setForm }) => {
  const { t } = useT();
  const [dataKey, lapKey, lapsKey, prefix] = KEYS[n];
  const data = form[dataKey];
  const stats = useMemo(() => (data ? lapStats(data) : null), [data]);

  const onImported = (parsed) => {
    const s = lapStats(parsed);
    setForm((f) => ({
      ...f,
      [dataKey]: parsed,
      ...(s.best && { [lapKey]: fmtLap(s.best.time, parsed.precision) }),
      ...(s.valid.length && { [lapsKey]: String(s.valid.length) }),
    }));
    toast.success(t("laps_imported"));
  };

  return (
    <div className="space-y-5">
      <LapImport prefix={prefix} data={data} onImported={onImported} onRemove={() => setForm((f) => ({ ...f, [dataKey]: null }))} />
      {data && <LapMeta prefix={prefix} meta={data.meta} />}
      {data && stats?.best && (
        <>
          <LapStats prefix={prefix} data={data} stats={stats} />
          <LapChart prefix={prefix} data={data} stats={stats} />
          <LapTable prefix={prefix} data={data} stats={stats} />
        </>
      )}
      {data && !stats?.best && <p data-testid={`${prefix}-no-valid`} className="font-mono text-sm text-[#FFB800]">{t("no_valid_laps")}</p>}
    </div>
  );
};

export const LapsTab = ({ form, setForm }) => {
  const { t } = useT();
  if (!form.pit) return <StintLaps n={1} form={form} setForm={setForm} />;
  return (
    <div className="space-y-10">
      {[1, 2].map((n) => (
        <section key={n} data-testid={`laps-stint-${n}`}>
          <h3 className="font-heading uppercase font-bold text-xl mb-3 flex items-center gap-2"><span className="w-1 h-4 bg-[#FFB800]" />PIT · {t(`stint${n}`)}</h3>
          <StintLaps n={n} form={form} setForm={setForm} />
        </section>
      ))}
    </div>
  );
};
